import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { settings } from "../redux/settings/actions";
import * as R from "ramda"
import { uploadFiles } from "../redux/upload-files/action";
import { selectUploadFileCreatedItem, selectUploadFileQueryItems, selectUploadFilesListItems } from "../redux/upload-files/selector";
import { FaCamera, FaFile, FaVideo } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import _ from "lodash";
import TabContainer from "../common/components/tab/containers/tab.containers";
import storePersist from "../redux/storePersist";

let chosenFiles: any = []
export default function UploadFiles({ handleClose, isSingleUpload, currentFilesSrc, folder, handleFilesSubmit, type, subFolder, ownerId }: any) {
	var tenantId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;
	const dispatch = useAppDispatch();
	const currentFile = useAppSelector(selectUploadFileCreatedItem)
	const queryFile = useAppSelector(selectUploadFileQueryItems)
	const listFiles = useAppSelector(selectUploadFilesListItems)

	const [
		selectedFileSRC,
		setSelectedFileSRC
	] = useState<any>()


	const getFilesReady = (event: any) => {
		chosenFiles = []
		R.map(
			(file) => {
				chosenFiles.push(file);
				return file;
			},
			event.target.files
		)
	}
	const uploadChosenFiles = () => {
		const frmData = new FormData();

		frmData.append(
			'DigiiFolderName',
			folder
		)
		frmData.append(
			'DigiiDocTypeName',
			type
		)
		frmData.append(
			'SubFolderName',
			subFolder || ''
		)
		frmData.append(
			'OwnerId',
			ownerId || 0
		)
		frmData.append(
			'TenantId',
			tenantId || 0
		)
		R.map(
			(file) => {
				frmData.append(
					'documents',
					file
				);
				return file
			},
			chosenFiles
		)

		dispatch(uploadFiles.create({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs`,
			entity: 'uploadFiles',
			jsonData:
				frmData


		})).then(() => {

			if (isSingleUpload) {
				fetchFile(currentFile?.result)
			} else {
				fetchFiles();
			}
		})
		chosenFiles = [];


	}

	const fetchFile = async (id: any) => {
		dispatch(uploadFiles.query({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api//v6.0/dms/digii-docs/query`,
			entity: 'uploadFiles',
			jsonData: {
				Records: [{
					Context: {},
					Message: {
						TenantId: tenantId,
						Id: id
					}
				}

				]
			}
		}))

		setSelectedFileSRC(queryFile?.result?.items?.DocumentPath)
	}
	const fetchFiles = async () => {
		dispatch(uploadFiles.list({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs/query-by-digiifolder`,
			entity: 'uploadFiles',
			jsonData: {
				Records: [{
					Context: {},
					Message: {
						TenantId: tenantId,
						OwnerId: ownerId,
						DigiiFolderName: folder,
						DigiiDocTypeName: type,
						SubFolderName: ''
					}
				}

				]
			}
		}))


	}

	const onSubmit = () => {

		handleFilesSubmit(selectedFileSRC);
		handleClose()
	}
	const setSelectedFileSrc = (fileSrc: any) => {
		setSelectedFileSRC(fileSrc)
	}

	useEffect(
		() => {
			setSelectedFileSRC(currentFilesSrc)
		},
		[]
	)

	useEffect(
		() => {
			if (!isSingleUpload && folder) {
				setTimeout(() => {
					fetchFiles();
				})
			}
		},
		[folder]
	)
	const deleteUploadFile = async (item: any) => {

		dispatch(uploadFiles.delete({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs/delete`,
			entity: 'uploadFiles',
			jsonData: {
				Records: [{
					Context: {},
					Message: {
						TenantId: tenantId,
						Id: item?.Id
					}
				}

				]
			}
		})).then(() => {
			fetchFiles()
		})



	}
	const imageTabItems = [
		{
			id: 1,
			title: 'Upload File',
			component: (
				<>
					{listFiles?.result?.items
						? <div className=" flex overflow-auto">
							{_.map(
								listFiles?.result?.items,
								(file: any, index: any) => (
									<div
										onClick={() => { setSelectedFileSrc(file?.DocumentPath); }}
										className=" mr-2 cursor-pointer text-center"
									//style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
									>
										<img
											alt="Product Image"
											src={file?.DocumentPath}
											className=" w-32"
										/>
										<div className=" text-center ml-auto text-sm">{file?.DocumentName}</div>
										{file
											? <div onClick={() => deleteUploadFile(file)}>
												<MdDelete className=" text-red-600" />

											</div>
											: <></>}
									</div>
								)
							)}
						</div>
						: null}
					<div
						className=" flex place-items-start mt-2  mb-2"
					//style={{ display: 'flex', justifyContent: 'start', marginTop: 3, marginBottom: 3 }}
					>
						<input
							accept="image/*"
							id="icon-button-file"
							multiple={!isSingleUpload}
							onChange={(event) => { getFilesReady(event); }}
							type="file"
						/>

						<button onClick={uploadChosenFiles} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
							Upload
						</button>
					</div>
				</>

			),
			isVisible: true,
		},
		{
			id: 2,
			title: 'Add Url',
			component: (
				<div>
					<textarea
						id="outlined-multiline-static"

						onChange={(event) => { setSelectedFileSRC(event.target.value); }}
						rows={4}
						style={{ width: '100%' }}
						value={selectedFileSRC}


					/>
					<div style={{ color: 'red' }}>
						<u>Note:</u> The file present in the given URL is
						not
						stored in
						the
						application.
					</div>
				</div>
			),
			isVisible: true,
		},
	]
	const videoTabItems = [
		{
			id: 1,
			title: 'Upload File',
			component: (
				<>
					{listFiles?.result?.items
						? <div className=" flex overflow-auto">
							{_.map(
								listFiles?.result?.items,
								(file: any, index: any) => (
									<div
										onClick={() => { setSelectedFileSrc(file?.DocumentPath); }}
										style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
									>
										<video

											src={file?.DocumentPath}
											className=" w-32"
										/>
										<div className=" text-center ml-auto text-sm">{file?.DocumentName}</div>
										{file
											? <div onClick={() => deleteUploadFile(file)}>
												<MdDelete className=" text-red-600" />

											</div>
											: <></>}
									</div>
								)
							)}
						</div>
						: null}
					<div style={{ display: 'flex', justifyContent: 'start', marginTop: 3, marginBottom: 3 }}>
						<input
							accept="video/*"
							id="icon-button-file"
							multiple={!isSingleUpload}
							onChange={(event) => { getFilesReady(event); }}
							type="file"
						/>

						<button onClick={uploadChosenFiles} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
							Upload
						</button>
					</div>
				</>

			),
			isVisible: true,
		},
		{
			id: 2,
			title: 'Add Url',
			component: (
				<div>
					<textarea
						id="outlined-multiline-static"

						onChange={(event) => { setSelectedFileSRC(event.target.value); }}
						rows={4}
						style={{ width: '100%' }}
						value={selectedFileSRC}


					/>
					<div style={{ color: 'red' }}>
						<u>Note:</u> The file present in the given URL is
						not
						stored in
						the
						application.
					</div>
				</div>
			),
			isVisible: true,
		},
	]
	const documentTabItems = [
		{
			id: 1,
			title: 'Upload File',
			component: (
				<>
					{listFiles?.result?.items
						? <div className=" flex overflow-auto">
							{_.map(
								listFiles?.result?.items,
								(file: any, index: any) => (
									<div
										onClick={() => { setSelectedFileSrc(file?.DocumentPath); }}
										style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
									>

										<div className=" text-center ml-auto text-sm" >{file?.DocumentName}</div>
										{file
											? <div onClick={() => deleteUploadFile(file)}>
												<MdDelete className=" text-red-600" />

											</div>
											: <></>}
									</div>
								)
							)}
						</div>
						: null}
					<div style={{ display: 'flex', justifyContent: 'start', marginTop: 3, marginBottom: 3 }}>
						<input
							accept="file/*"
							id="icon-button-file"
							multiple={!isSingleUpload}
							onChange={(event) => { getFilesReady(event); }}
							type="file"
						/>

						<button onClick={uploadChosenFiles} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
							Upload
						</button>
					</div>
				</>

			),
			isVisible: true,
		},
		{
			id: 2,
			title: 'Add Url',
			component: (
				<div>
					<textarea
						id="outlined-multiline-static"

						onChange={(event) => { setSelectedFileSRC(event.target.value); }}
						rows={4}
						style={{ width: '100%' }}
						value={selectedFileSRC}


					/>
					<div style={{ color: 'red' }}>
						<u>Note:</u> The file present in the given URL is
						not
						stored in
						the
						application.
					</div>
				</div>
			),
			isVisible: true,
		},
	]
	return (
		<>
			{type &&
				(
					<div className="absolute fixed inset-0 flex justify-center items-center mt-3 modal-overlay ml-12">
						<div className="my-2 mx-auto w-full max-w-[90vw] lg:max-w-[1100px] ">
							<div className="rounded-lg shadow-lg flex flex-col w-[1100px] bg-white  h-[80vh] p-4 overflow-auto bg-scroll">
								<div className="flex items-start justify-between w-full border-b p-2">
									<div className="flex w-full flex-col items-start justify-between text-lg" >
										Upload Files
									</div>
									<div className="cursor-pointer mx-1">
										<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
									</div>
								</div>
								<div className="w-full flex flex-row p-1 ">
									<div className="w-1/3">
										<div className="flex w-full flex-col items-start justify-between text-md" >
											Currenct File
										</div>
										<div>
											{type === 'image' &&
												<>
													<div className=" flex overflow-auto">
														{currentFilesSrc
															? <div
																onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
																style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
															>
																<img

																	src={currentFilesSrc}
																	className=" w-48"
																/>
															</div>
															: null}
													</div>
												</>}
											{type === 'video' && <>
												<>
													<div className=" flex overflow-auto">
														{currentFilesSrc
															? <div
																onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
																style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
															>

																<h3><FaVideo /></h3>
																<div style={{ textAlign: 'center', wordBreak: 'break-word' }}>{currentFilesSrc}</div>
															</div>
															: null}
													</div>
												</>
											</>}
											{type === 'document' && <>
												<div className=" flex overflow-auto">
													{currentFilesSrc
														? <div
															onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
															style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
														>
															<h3><FaFile /></h3>
															<div style={{ textAlign: 'center', wordBreak: 'break-word' }}>{currentFilesSrc}</div>
														</div>
														: null}
												</div>

											</>}
										</div>
										{!currentFilesSrc && <div style={{ color: '#2B60E9' }}>
											No file selected
										</div>}


									</div>
									<div className="w-2/3">
										{type === 'image' &&
											<>
												{selectedFileSRC && <div >
													<img
														alt="Product Image"
														src={selectedFileSRC}
														className=" w-72 h-48 "
													/>
												</div>}

												{!selectedFileSRC &&
													<div
														className=" justify-center items-center flex w-auto"
													//style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
													>
														<h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
															No file selected
														</h5>
													</div>}
												<TabContainer tabItems={imageTabItems} />
											</>}

										{type === 'video' &&
											<>
												<div >
													{selectedFileSRC
														? <video
															autoPlay
															controls
															loop
															muted
															preload="auto"
															src={selectedFileSRC}
														/>
														: null}

													{!selectedFileSRC &&
														<div

															style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
														>
															<h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
																No file selected
															</h5>
														</div>}
												</div>

												<TabContainer tabItems={videoTabItems} />
											</>}

										{type === 'document' &&
											<>
												<div >
													{selectedFileSRC
														? <iframe
															src={selectedFileSRC}
															title="Document"
														/>
														: null}
													{!selectedFileSRC &&
														<div

															style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
														>
															<h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
																No file selected
															</h5>
														</div>}
												</div>

												<TabContainer tabItems={documentTabItems} />
											</>}
									</div>
								</div>
								<div className="w-full flex flex-row p-1 ">
									<div className="w-1/4">

									</div>
									<div className="w-3/4">
										<div className="flex flex-row justify-end items-center space-x-2">

											<button onClick={onSubmit} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
												Save
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div >
				)}
		</>
	);
}